import { ROUTES } from "@nf/constants";
import { ScreenType } from "../enums";
import { useConfigurationSelector } from "../selectors";
import { IConfigurationModel } from "../models";

export const useHomeUrl = (configuration?: IConfigurationModel) => {
  const configurationState = useConfigurationSelector();
  const homeId = (configurationState ?? configuration)?.Screens?.[
    ScreenType.Home
  ]?.Id;

  if (homeId) {
    return `${homeId}`;
  }

  return ROUTES.BASE;
};
